import React from "react"
//import styles from "./SpinnerDot.css"

function SpinnerDot() {
    return (
        <div className="spinner">
            <div className="dot1"></div>
            <div className="dot2"></div>
        </div>
    )
}

export default SpinnerDot
